import { render, staticRenderFns } from "./DocumentSetup.vue?vue&type=template&id=cbf6df82&scoped=true&"
import script from "./DocumentSetup.vue?vue&type=script&lang=js&"
export * from "./DocumentSetup.vue?vue&type=script&lang=js&"
import style0 from "./DocumentSetup.vue?vue&type=style&index=0&id=cbf6df82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbf6df82",
  null
  
)

export default component.exports